/**
 * «مشكاة» — an optional skin over the current design (2026-09-27).
 *
 * Everything it is lives in src/skin/: this file, SkinToggle.js and
 * mishkah.css. Every rule in the stylesheet is scoped under
 * html[data-skin="mishkah"], so with the switch off NOTHING changes.
 * To remove it for good, see README.md in this folder (3 lines).
 *
 * The choice is per account (localStorage `mtz.skin.<user id>`), offered
 * to every staff account. «مشكاة» is the default (owner, 2026-09-27);
 * the switch goes back to the previous look.
 */
import './mishkah.css';

const key = (uid) => `mtz.skin.${uid ?? 'anon'}`;
const FONT_ID = 'mtz-skin-font';
// The calligraphic brand name, same font as the welcome intro.
const FONT_HREF = 'https://fonts.googleapis.com/css2?family=Aref+Ruqaa:wght@700&display=swap';

/** Who may see the switch (and the skin). */
export const skinAllowed = (user) => !!user;

export function savedSkin(uid) {
  try { return localStorage.getItem(key(uid)) === 'classic' ? 'classic' : 'mishkah'; } catch { return 'mishkah'; }
}

export function saveSkin(uid, skin) {
  try { localStorage.setItem(key(uid), skin); } catch { /* private window: this session only */ }
}

function loadFont() {
  if (document.getElementById(FONT_ID)) return;
  const l = document.createElement('link');
  l.id = FONT_ID;
  l.rel = 'stylesheet';
  l.href = FONT_HREF;
  document.head.appendChild(l);
}

export function applySkin(skin) {
  const root = document.documentElement;
  if (skin === 'mishkah') {
    root.setAttribute('data-skin', 'mishkah');
    loadFont();
  } else {
    root.removeAttribute('data-skin');
  }
}

// Before the first paint, so a reload never flashes the other look.
try {
  const u = JSON.parse(localStorage.getItem('mtzedu_session_user') || 'null');
  if (skinAllowed(u)) applySkin(savedSkin(u.id));
} catch { /* no saved session */ }
